/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'Shop/ShoppingBag': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" fill-rule="evenodd" d="M18 7h-4V5h4v2zm7.75 0H20V4.689a.248.248 0 0 0-.073-.176l-1.44-1.44A.248.248 0 0 0 18.311 3h-4.622a.248.248 0 0 0-.176.073l-1.44 1.44a.248.248 0 0 0-.073.176V7H6.25a.25.25 0 0 0-.25.25v19.501c0 .138.111.249.249.249h1.502A.248.248 0 0 0 8 26.751V9h16v15.74a.26.26 0 0 1-.26.26H10.941a.25.25 0 0 0-.227.146l-.691 1.5a.25.25 0 0 0 .227.354h14.332c.783 0 1.418-.635 1.418-1.418V7.25a.25.25 0 0 0-.25-.25z"/>'
  }
})
